import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IBackButton {
  url?: string;
  // Go back in the browser history when the user came from another page of the app, so a list
  // keeps its filters; "url" is then only the fallback (e.g. the page was opened directly)
  preferHistory?: boolean;
  id: string;
  sx?: React.CSSProperties;
}

const WSBackButton: React.FC<IBackButton> = ({ url: initialUrl, preferHistory = false, id, sx }) => {
  const navigate = useNavigate();
  const [url] = useState(initialUrl);

  const handleBack = () => {
    // react-router stores the position in the history stack; above 0 means there is a page to return to
    if (preferHistory && (window.history.state?.idx ?? 0) > 0) navigate(-1);
    else if (url) navigate(url);
    else navigate(-1);
  };

  return (
    <Box
      onClick={handleBack}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        border: "1.5px solid #15B788", // Figma green border
        background: "#FFFFFF",
        padding: "6px 14px",
        borderRadius: "40px", // full oval shape
        width: "fit-content",
        cursor: "pointer",
        "&:hover": {
          background: "#F6FFFB",
        },
        ...sx
      }}
    >
      <ArrowBackIcon
        sx={{
          color: "#15B788",
          fontSize: 20
        }}
      />

      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: "#15B788", // green text same as figma
          fontSize: "16px",
        }}
      >
      Back
      </Typography>
    </Box>
  );
};

export default WSBackButton;
